module.exports = __webpack_public_path__ + "static/media/blue-circle-bottom.15545c90.png";